module.exports = __webpack_public_path__ + "static/media/img_landing10.5f7f1feb.png";